module.exports = __webpack_public_path__ + "static/team-pranav-goyal-d09506c571729b54b3c3474dd6585f4c.jpeg";